import React from 'react'
var AboutHeaders={
    backgroundImage: 
    "url('/images/BannerImages/Aboutushero.jpg')",
    marginTop:"0px"
  }
export default function AboutHero() {
  return (
    <>
         <section id="Aboutus-hero" style={AboutHeaders}>
        <h2>#StayHome</h2>    
        <p>Save more with coupons and upto 70% off</p>

</section> 
    </>
  )
}
